import { Routes, Route } from 'react-router-dom'
import Header from './components/header/Header'
import Footer from './components/footer/Footer'
import Error404 from './pages/Error404/Error404'
import ReserverEnLigne from './pages/reserver-en-ligne/ReserverEnLigne'
import OffresAbonnement from './pages/OffresAbonnement/OffresAbonnement'
import Accueil from './pages/Accueil/Accueil'
import PlanityGift from './components/planity/Gift/PlanityGift'
import Services from './pages/Services/Services'
import MentionsLegales from './pages/Legal/MentionsLegales'
import Cgu from './pages/Legal/Cgu'
import { ConsentGate } from './consent/ConsentGate'
import { useAnalyticsConsent } from './analytics/useAnalyticsConsent'
import { usePageviews } from './analytics/usePageviews'
import { useMetadonnees } from './metadonnees/useMetadonnees'
import { useDonneesStructurees } from './metadonnees/useDonneesStructurees'

function App() {
  // Montés ici, une seule fois : la mesure ne rend rien, elle n'a besoin
  // d'aucun contexte ni d'aucun fournisseur autour de l'arbre.
  useAnalyticsConsent()
  usePageviews()
  // Même raison, et une de plus : laissées aux pages, les métadonnées
  // seraient oubliées par la prochaine — c'est ce qui s'était produit, huit
  // pages posant leur titre et aucune sa description.
  useMetadonnees()
  // Le balisage Schema.org de l'établissement, posé sur la seule page
  // d'accueil : il décrit le lieu, pas la page courante.
  useDonneesStructurees()

  return (
    <div className="App">
      <Header />
      <div className="main">
        <div className="container" id='container'>
          <Routes>
            <Route path='/' element={<Accueil />} />
            <Route path='/accueil' element={<Accueil />} />
            <Route path='/offres-abonnement' element={<OffresAbonnement />} />
            <Route path='/team' element={<Error404 />} />
            <Route path='/services' element={<Services />} />
            <Route path='/reserver-en-ligne' element={<ReserverEnLigne />} />
            <Route path='/mentions-legales' element={<MentionsLegales />} />
            <Route path='/cgu' element={<Cgu />} />


            {/* Pages dédiées au service Planity */}
            <Route path='/offrir' element={<PlanityGift />} />
            {/* ==================================================== */}

            
            <Route path='*' element={<Error404 />} />
          </Routes>
        </div>
      </div>
      <Footer />
      <ConsentGate />
    </div>
  );
}

export default App;
